import acornSrc from "@/assets/brand/acorn.png";

/**
 * The extracted acorn from the "Orterie" brand — used as a tone-on-tone placeholder
 * whenever a wine has no image yet. Elegant, discreet, and consistent with the brand.
 */
export function AcornPlaceholder({ size = 96, className = "", opacity = 0.55 }) {
    return (
        <img
            src={acornSrc}
            alt=""
            aria-hidden="true"
            className={className}
            style={{
                width: "auto",
                height: size,
                opacity,
                filter: "grayscale(20%)",
                objectFit: "contain",
                display: "block",
            }}
        />
    );
}

export const TYPE_LABEL = {
    rosso: "Rosso",
    bianco: "Bianco",
    rosato: "Rosato",
    bollicine: "Bollicine",
    dolce: "Dolce",
};

/**
 * Build an absolute URL from a backend-relative image path.
 * If the path is already absolute (http/https), return as-is.
 */
export function absMediaUrl(pathOrUrl) {
    if (!pathOrUrl) return null;
    if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
    const base = process.env.REACT_APP_BACKEND_URL || "";
    return `${base}${pathOrUrl}`;
}
